import React from "react";
import { Link } from "react-router-dom";

import "../assets/css/utility/footer.css";
import FooterBg from "../assets/media/background/footer-bg.png";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundImage: `url(${FooterBg})`,
      }}
    >
      <div className="container position-relative z-index-9">
        <div className="row align-items-end">
          <div className="col-lg-4">
            <p className="copy-right">© 2022 | Poncor Dispatch Marketplace.</p>
            <p className="copy-right">
              Product of
              <a className="use-full-link" rel="noreferrer" href="#" target={"_blank"}>
                <b>Padmore Global Connections LLC</b>
              </a>
            </p>
            <p className="copy-right">
              Develop By 
              <a className="use-full-link" rel="noreferrer" href="https://vaid.tech/en/" target={"_blank"}>
                <b>Vaid Tech Services</b>
              </a>
            </p>
          </div>
          <div className="col-lg-3">
            <div className="social-link">
              {/* Social media link is termporarly otherwise showing error for blank href */}
                <a href="https://x.com/padmoreglobalc/" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-twitter"></i>
                </a>
                <a href="https://www.instagram.com/padmoreglobalcon/" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-instagram"></i>
                </a>
                <a href="https://www.facebook.com/profile.php?id=61559922069510" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-facebook"></i>
                </a>
                <a href="https://www.linkedin.com/company/47587687" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-linkedin"></i>
                </a>
            </div>
          </div>
          <div className="col-lg-2">

            <Link to="/contact" className="use-full-link">Contact Us</Link>

            <Link to="/privacy-Policy" className="use-full-link">
              Privacy Policy
            </Link>
            <Link to="/terms-conditions" className="use-full-link">
              Terms & Conditions
            </Link>
          </div>
          <div className="col-lg-3">
            <p className="footer-address-info">
              <a className="use-full-link" href="tel:240-478-2730">
                240-478-2730
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
